import { BottomNavigation, BottomNavigationAction, Paper, } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export default function HeaderRoutes({ step = 0, steps = [] }) {
  const [value, setValue] = React.useState(step);

  return (
    <>
      <Paper className="main-nav" elevation={0}  
        sx={{ 
          height: '45px', 
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
          // width:'100% !important'
        }}>
        <BottomNavigation
          sx={{
            overflow: "auto",
            height: "auto",
            minHeight: "45px",
            scrollbarWidth:'none !important',
            "& .MuiButtonBase-root": {
              maxWidth: "unset",
              minWidth: "unset",
            },
          }}
          className="justify-content-start scroll-bar"
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          {steps &&
            steps.map((item, index) => {
              if (item.hide) {
                return;
              }
              if (item.disable) {
                return (
                  <BottomNavigationAction
                    key={index + "navi"}
                    sx={{
                      color: "#555555",
                      "& .MuiBottomNavigationAction-label":
                      {
                        whiteSpace:"nowrap !important",
                        fontWeight: "500",
                        fontSize: "14px !important",
                      },
                      "& .Mui-selected": {
                        color: "#fff",
                        fontSize: "14px !important",
                        borderRadius:'30px'
                      },
                      ".Mui-selected&": {
                        color: "#fff",
                        backgroundColor:'#BF1D2D',
                        borderRadius:'30px'
                      },
                    }}
                    label={item.label}
                    disabled
                    className="m-1"
                  />
                );
              }
              return (
                <BottomNavigationAction
                  key={index + "navi"}
                  sx={{
                    color: "#555555",
                    "& .MuiBottomNavigationAction-label": {
                      whiteSpace: "nowrap !important",
                      fontWeight: "500",
                      fontSize: "14px !important",
                      borderRadius:'30px'
                    },
                    "& .Mui-selected": {
                      color: "#fff",
                      fontSize: "14px !important",
                      borderRadius:'30px'
                    },
                    ".Mui-selected&": {
                      color: "#fff",
                      backgroundColor:'#BF1D2D',
                      borderRadius:'30px'
                    },
                  }}
                  label={item.label}
                  component={Link}
                  to={item.link}
                  className="m-1"
                />
              );
            })}
        </BottomNavigation>
      </Paper>
    </>
  );
}
